<template>
  <main class="story-shell">
    <iframe class="story-frame" :src="storySource" title="라피아 공주 이야기" allow="fullscreen"></iframe>
    <v-btn v-if="isDetail" fixed bottom right color="primary" large class="story-reserve-btn" rounded elevation="6" @click="goReserve">
      <v-icon left>mdi-calendar-check</v-icon>
      {{ $t("button.do-reserve") }}
    </v-btn>
  </main>
</template>

<script>
export default {
  computed: {
    isDetail() {
      return this.$route.name === "princess-story-detail"
    },
    storySource() {
      const params = new URLSearchParams()
      Object.keys(this.$route.query).forEach((key) => {
        const value = this.$route.query[key]
        if (Array.isArray(value)) value.forEach((item) => params.append(key, item))
        else if (value != null) params.set(key, value)
      })
      params.set("embedded", "1")
      const page = this.$route.name === "princess-story-detail" ? "/mian_00_story_list.html" : "/mian_00_story.html"
      return `${page}?${params.toString()}`
    },
  },
  mounted() {
    window.addEventListener("message", this.handleStoryNavigation)
  },
  beforeDestroy() {
    window.removeEventListener("message", this.handleStoryNavigation)
  },
  methods: {
    goReserve() {
      const query = {}
      if (this.$route.query.conceptId) query.conceptId = this.$route.query.conceptId
      if (this.$route.query.event) query.event = this.$route.query.event
      this.$router.push({ path: "/booking/reserve", query }).catch(() => {})
    },
    handleStoryNavigation(event) {
      if (event.origin !== window.location.origin || event.source !== this.$el.querySelector("iframe").contentWindow) return
      if (event.data && event.data.type === "lafia-story-open") {
        this.$router.push({ name: "princess-story-detail", query: event.data.query }).catch(() => {})
      }
      if (event.data && event.data.type === "lafia-story-back") {
        this.$router.push({ name: "princess-story" }).catch(() => {})
      }
    },
  },
}
</script>

<style scoped>
.story-shell {
  width: 100%;
  height: calc(100vh - 132px);
  height: calc(100dvh - 132px);
  margin-bottom: 72px !important;
  overflow: hidden;
  background: #fff;
}

.story-frame {
  display: block;
  width: 100%;
  height: 100%;
  border: 0;
  background: #fff;
}

.story-reserve-btn {
  z-index: 12;
}
</style>
